module.exports = __webpack_public_path__ + "static/media/student-end-season-gold.df0c0cb5.png";